<script setup lang="ts">
defineProps<{
  label: string
  content?: string
}>()
</script>

<template>
  <div class="flex flex-col gap-0.5">
    <p class="text-muted-foreground text-xs">{{ label }}</p>
    <p>{{ content }} <slot v-if="!content" /></p>
  </div>
</template>
